import { render, staticRenderFns } from "./ListProductStock.vue?vue&type=template&id=32619d22&scoped=true"
import script from "./ListProductStock.vue?vue&type=script&lang=js"
export * from "./ListProductStock.vue?vue&type=script&lang=js"
import style0 from "./ListProductStock.vue?vue&type=style&index=0&id=32619d22&prod&scoped=true&lang=css"
import style1 from "./ListProductStock.vue?vue&type=style&index=1&id=32619d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32619d22",
  null
  
)

export default component.exports